// `emailAlreadyRegistered` é o código antigo do authentication-api, aceito até a APR-3527 chegar em produção.
const ACCOUNT_CONFLICT_CODES = [
  'accountAlreadyExists',
  'emailAlreadyRegistered',
];

const FALLBACK_DESCRIPTION =
  'Contate-nos através do chat, localizado no ícone no canto inferior direito, para prosseguir.';

export interface AccountConflictError {
  message: string;
  description: string;
}

export function accountConflictError(error?: {
  code?: string;
  errorMessages?: string[];
}): AccountConflictError | null {
  if (!error?.code || !ACCOUNT_CONFLICT_CODES.includes(error.code)) {
    return null;
  }

  return {
    message: 'Não foi possível criar sua conta.',
    description: error.errorMessages?.[0] || FALLBACK_DESCRIPTION,
  };
}
